<div class="forbidden-page">
  <img class="iren-logo" src="content/assets/images/svg/LOGO_IREN_LGS.svg">
  <h1>Ops, la pagina che stai cercando non è disponibile.</h1>
</div>
